<div class="flex flex-col gap-1 w-full animate-fade-in p-4">
  <app-header
    title="Endpoint Permissions"
    searchPlaceholder="Search permissions..."
    [showFilter]="false"
    [showNew]="false"
    [showSecondaryButton]="true"
    secondaryButtonIcon="pi pi-sync"
    secondaryButtonTooltip="Sync permissions"
    (onSearch)="handleSearch($event)"
    (onSecondaryClick)="syncPermissions()"
  ></app-header>

  <app-table
    [allData]="tableData"
    [columns]="tableColumns"
    [actions]="tableActions"
    [totalRecords]="totalRecords"
    [loading]="loading || syncing"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    (onLazyLoad)="loadLazy($event)"
  >
  </app-table>
</div>
